// Platform-wide "Enter = primary action" keyboard behaviour.
// If any dropdown/popover is open, Enter belongs to it; once everything is closed,
// Enter triggers the given action (Apply / Save) — even when focus rests on a
// select trigger after picking a value.

const TEXT_TYPES = new Set(["text", "email", "number", "password", "search", "tel", "url", ""]);

export const popperOpen = () => !!document.querySelector("[data-radix-popper-content-wrapper]");

export const isEnterActionTarget = (t) => {
  if (!t) return false;
  const tag = (t.tagName || "").toLowerCase();
  if (tag === "textarea" || t.isContentEditable) return false;
  if (tag === "input") return TEXT_TYPES.has((t.getAttribute("type") || "").toLowerCase());
  if (t.getAttribute && t.getAttribute("role") === "combobox") return true;
  return !!(t.closest && t.closest("[data-enter-submit]"));
};

export const enterToAction = (action) => (e) => {
  if (e.key !== "Enter" || e.shiftKey || !action) return;
  if (popperOpen()) return; // an open dropdown owns Enter
  if (!isEnterActionTarget(e.target)) return;
  e.preventDefault();
  action();
};
